import { Component, Input } from '@angular/core';
import {DatePipe} from "@angular/common";
import { User } from '../../models/usermodel';
import { Account } from '../../models/accountmodel';
import { UserUpdate } from '../../models/userupdatemodel';
import { userService }   from '../../services/user.service';
import { SharedService }   from '../../services/sharedservices.service';
import { Session } from '../../models/sessionmodel';
import { AcctResponse } from '../../models/accountresponse';
import { FormBuilder, Validators, FormGroup, FormControl } from '@angular/forms';
import {Router} from  '@angular/router';
import { CurrencyPipe } from '@angular/common';
import { accountService } from 'services/account.service';

@Component({
  templateUrl: './user.component.html',
  styleUrls: ['../../css/sb-admin.min.css'],
  providers: [userService, accountService]
})

export class UserComponent {
  @Input() responseObj: Session;
  public users: User[];
  public accounts: Account[];
  public user: User;
  public userUpdate: UserUpdate;
  public data;
  errorMessage: string;
  public itemResource;
  public acctresp : AcctResponse;
  items = [];
  itemCount = 0;
  public filterQuery = "";
  public rowsOnPage = 10;
  public sortBy = "storeid";
  public sortOrder = "asc";

 

  constructor(public _userService: userService,public _accountService: accountService, public router: Router, public sharedservice: SharedService) {    
  }

  ngOnInit()
  {   
      // call the method on initial load of page to bind dropdown      
      this.user = new User();        
      this.userUpdate =  new UserUpdate();   
      this.getAccounts();
      this.getUsers();      
  }

  postUser(isValid: boolean){
    if(isValid){
      this._userService.postUser(this.user).subscribe(res => this.handlePostResponse(res), error => this.errorMessage = <any>error);
      this.getUsers();
    }
  }

 updateUser(isValid: boolean){
    if(isValid){      
      this._userService.updateUser(this.userUpdate).subscribe(res => res, error => this.errorMessage = <any>error);      
      this.getUsers();
    }
  }

  //Get the list of accounts
  getUsers() {
      this._userService.getUsers().subscribe(res => this.handleResponse(res), error => this.errorMessage = <any>error);
  }

   //Get the list of accounts
  retrieveUser(storeid) {     
      var racct = this.users.find(a => a.storeid == storeid);
      this.userUpdate.accounttype = racct.accounttype;     
      this.userUpdate.role = racct.role;
      this.userUpdate.storeid = racct.storeid;
      this.userUpdate.userstore= racct.userstore;
   }

   //Get the list of accounts
  getAccounts() {
    this._accountService.getAccounts().subscribe(res => this.handleAccountResponse(res), error => this.errorMessage = <any>error);
  }

  handleAccountResponse(result){
    //console.log('Accounts - ' + JSON.stringify(result));
    this.accounts = result;      
    
  }

  handleResponse(result){
    //console.log('users - ' + JSON.stringify(result));
    this.users = result;  
    this.data  = result;  
    
  }

  handlePostResponse(result){
    this.acctresp = result;
  }

}



// WEBPACK FOOTER //
// /payu/microservice/multichannelportal/src/app/user/user.component.ts